import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const hasProcessed = useRef(false);
    const navigate = useNavigate();
    const { setUser, refresh } = useAuth();

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const hash = window.location.hash || '';
        const params = new URLSearchParams(hash.replace(/^#/, ''));
        const sessionId = params.get('session_id');
        if (!sessionId) {
            navigate('/login', { replace: true });
            return;
        }
        (async () => {
            try {
                const r = await api.post('/auth/session', { session_id: sessionId });
                // 1. Persist token to localStorage (fallback when 3rd-party cookies blocked)
                if (r.data?.session_token) {
                    try { localStorage.setItem('session_token', r.data.session_token); } catch (e) {
                        console.error('[auth] localStorage write failed', e);
                    }
                }
                // 2. Populate user immediately (don't rely on a full reload + new /auth/me roundtrip)
                if (r.data?.user) {
                    setUser(r.data.user);
                }
                // 3. Clear the hash to avoid loops, then navigate via react-router
                //    (no full reload — keeps the React app + AuthContext alive)
                if (window.history?.replaceState) {
                    window.history.replaceState(null, '', '/dashboard');
                }
                // 4. Background refresh to make sure /auth/me agrees (catches any cookie weirdness)
                refresh().catch(() => null);
                navigate('/dashboard', { replace: true });
            } catch (e) {
                console.error('Auth exchange failed', e);
                navigate('/login?err=auth', { replace: true });
            }
        })();
    }, [navigate, setUser, refresh]);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-brand-bg gap-3">
            <div className="w-10 h-10 rounded-full border-2 border-brand-green border-t-transparent animate-spin" />
            <div className="text-brand-ink text-lg font-serif">Signing in…</div>
        </div>
    );
}
